import React, { useContext, useState } from 'react'
import { Alert } from 'components'
import { AutoComplete, Button } from 'components/Form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { CreateBatteryStyles } from './Style'
import { assignAssessmentToLearningGroupFetch } from 'store/middlewares/assessment.crud'
import { AssessmentsContext } from './AssessmentsContext'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { getLearningGroupsFetch } from 'store/middlewares/testTakers.crud'

const AssignAssessmentAlert = (props) => {
    const { handleAlert = () => { } } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments, assessmentOptions } = useContext(AssessmentsContext)
    const queryClient = useQueryClient()

    const [learningGroup, setLearningGroup] = useState(null)

    const learningGroups = useQuery({
        queryFn: [qc.learningGroups],
        queryFn: async () => {
            const { data } = await getLearningGroupsFetch()
            return data
        }
    })

    const { mutateAsync: assignAssessmentToLearningGroup, isPending } = useMutation({
        mutationFn: assignAssessmentToLearningGroupFetch,
        onSuccess: () => {
            handleAlert(false)
            setResetRowSelection(true)
            setSelectedAssessments(null)
            queryClient.invalidateQueries({ queryKey: assessmentOptions.queryKey })
            toast(" העדכון בוצע בהצלחה", toastConfig)
        }
    })

    const handleAssign = () => {
        if (!learningGroup) {
            toast.error('בחר קבוצת למידה', toastConfig)
            return
        }
        assignAssessmentToLearningGroup({ learning_group: learningGroup?.id, assessment_ids: selectedAssessments })
    }

    return (
        <Alert
            systemUI
            title={"שיוך מבדקים ותלמידים לקבוצת למידה"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <div>
                    {"הפיצר נועד כדי לתקן שיוכים שלא בוצעו רטרו"}
                </div>
                <div>
                    {"הפיצר לא ידידותי ולא גמיש בכלל"}
                </div>
                <div>
                    {"כדי לשנות שיוך לא נכון שבצענו כאן זה לא המקום!!"}
                </div>
                <div>
                    <b>{"אם אחד מהמבדקים שבחרתן הוא חלק מסוללה, הסוללה תשמר תחת אותה יחידת למידה מתוך מסקנה שכל הסוללה שייכת לאותו יחידת למידה!!"}</b>
                </div>
                {""}
                <AutoComplete
                    input={{
                        value: learningGroup,
                        onChange: setLearningGroup
                    }}
                    placeholder="בחר קבוצת למידה"
                    options={learningGroups.data}
                />
                <div>
                    <Button
                        loading={isPending}
                        disabled={!learningGroups || isPending}
                        action={handleAssign}
                        color="thirdly"
                        label="שייך התלמידים לקבוצת הלמידה כולל המבדקים שנבחרו"
                    />
                </div>
            </CreateBatteryStyles>
        </Alert>
    )
}

export default AssignAssessmentAlert